import React from 'react';
import PageShell from '../../components/PageShell';
import AlbumMain from './AlbumMain';
import GalleryMain from './GalleryMain';

export const Gallery = () => (
  <PageShell>
    <GalleryMain />
  </PageShell>
);

export const Album = () => (
  <PageShell>
    <AlbumMain />
  </PageShell>
);
